import React, { useRef, useState, useMemo, useEffect } from 'react';
import JoditEditor from 'jodit-react';

// Common Component for JoditEditor
const JoditEditorComponent = ({ placeholder, onChange, value, disabled = false, height }) => {
  const editor = useRef(null);
  const [content, setContent] = useState(value || '');

  // Memoized configuration for the editor
  const config = useMemo(
    () => ({
      readonly: disabled ? true : false, // Make editor read-only based on disabled prop
      placeholder: '',
      height: height || 500,
      toolbar: {
        width: '100%', // Set to 100% for better responsiveness
      },
      toolbarButtonSize: 'middle',
      buttons: [
        // Row 1: Text formatting and alignment
        'bold', 'italic', 'underline', 'strikethrough', '|',
        'left', 'center', 'right', 'justify', '|', // Corrected alignment tools
        'superscript', 'subscript', '|',
        // Row 2: Lists, indentation, and media
        'ul', 'ol', '|',
        'outdent', 'indent', '|',
        'image', 'video', 'file', 'link', 'table', '|',
        // Row 3: Font styles, clipboard, and utilities
        'font', 'fontsize', 'brush', 'paragraph', '|',
        'cut', 'copy', 'paste', '|',
        'undo', 'redo', '|',
        'find', 'fullsize', 'source', 'preview'
      ],
      uploader: {
        insertImageAsBase64URI: true,
      },
      // Explicitly set default text color to black
      style: {
        color: 'black !important', // Add !important to increase specificity
      },
      // Set default font to Roboto
      defaultFontName: 'Roboto',
      // Set default font size to 16px
      defaultFontSize: '16px',
      // Force editor content area to use black as default
      editorCssClass: 'jodit-custom-black-text',
    }),
    [disabled, placeholder]
  );

  // Handle content updates on blur
  const handleBlur = newContent => {
    setContent(newContent);
    onChange(newContent); // Trigger the onChange callback
  };

  // Update content state when the value prop changes
  useEffect(() => {
    setContent(value);
  }, [value]);

  return (
    <div style={{ width: "100%" }}>
      <style>
        {`
          .jodit-custom-black-text .jodit-wysiwyg {
            color: black !important;
          }
        `}
      </style>
      <JoditEditor
        ref={editor}
        value={content}
        config={config}
        tabIndex={1}
        onBlur={handleBlur}
        onChange={() => {}} // Required prop, can be empty if using onBlur
      />
    </div>
  );
};

export default JoditEditorComponent;